import { Component, Input } from '@angular/core';
import { TechnoBtnColors } from '@shared/ui-components/au-techno-btn/au-techno-btn.types';
import { AuTechnoBtnConfig } from '@shared/ui-components/au-techno-btn/au-techno-btn.config';
import { MatRippleModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable techno button with animation
 * @example
 *
 * ```
 * <au-techno-btn
 *    color="attention"
 *    [disabled]="false"
 * >
 *    Click me
 * </au-techno-btn>
 *
 * ```
 */

@Component({
	selector: 'au-techno-btn',
	templateUrl: './au-techno-btn.component.html',
	styleUrls: ['./au-techno-btn.component.scss'],
	imports: [MatRippleModule, CommonModule],
})
export class AuTechnoBtnComponent {
	@Input() color: TechnoBtnColors = 'ghost';
	@Input() disabled = false;
	@Input() fullWidth = false;
	@Input() styles: { [p: string]: any };

	config = AuTechnoBtnConfig;
}
